<template>
        
    <div class="card">
        <div class="card-body">

            <h4 
                class="card-title"
                :class="($i18n.locale == 'ar') ? 'hacen_algeria font-size-15' : ''">
                {{ $t('app.amount_duo') }}
            </h4>
            <div class="col-12 pd-0" style="padding:0">
                <input 
                    id="slug"
                    class="form-control text-lowercase" 
                    type="number" 
                    step="0.50"
                    v-model="row.amount_duo"
                    @keydown.space.prevent 
                    @paste="onPaste"
                    v-on:input="onChange">
            </div>
        </div>
    </div>
        
</template>

<script>
export default {
    namme: 'CardAmountDuo',
    props: [
        'amount_duo'
    ],
    data(){
        return {
            row: {
                amount_duo: this.$props.amount_duo
            },
        }
    },
    mounted() {},
    methods: {

        onChange(){
            const data = {
                amount_duo: this.row.amount_duo
            }
            this.$emit('amountDuoChange', data);
        },
        onPaste(){
            let str = this.row.amount_duo;
            this.preventSpace(str);
        },
        preventSpace(str){
            if(!str) {
                let str = this.row.amount_duo;
                this.row.amount_duo = str.replace(/\s+/g, '-');
            } else {
                this.row.amount_duo = str.replace(/\s+/g, '-');
            }
        },

    }
}
</script>
